export const MANUFACTURER_TYPE_VALUE = 1;
export const TRADER_TYPE_VALUE = 2;
export const BUYING_HOUSE_TYPE_VALUE = 3;
export const WHOLESALER_TYPE_VALUE = 4;
export const MSME_NO = 0;
export const UNDEFINED_VALUE = '--';
export const ACTIVATION_STATUS = {
  activated: 'Y',
  deactivated: 'N',
};
export const VERIFICATION_STATUS = {
  verified: 1,
  unverified: 0,
};
export const COUNTRY_OPTIONS = [
  { label: 'India', value: 'India' },
  { label: 'Bangladesh', value: 'bangladesh' },
  { label: 'Srilanka', value: 'srilanka' },
];

export const STATUS_OPTIONS = [
  { label: 'verified', value: 'verified' },
  { label: 'deactivated', value: 'deactivated' },
];
export const BUSINESS_NATURE = [
  { title: 'Factory', value: MANUFACTURER_TYPE_VALUE },
  { title: 'Trader', value: TRADER_TYPE_VALUE },
  { title: 'Buying House', value: BUYING_HOUSE_TYPE_VALUE },
  { title: 'Wholesaler', value: WHOLESALER_TYPE_VALUE },
];

export const BUSINESS_NATURE_TYPE = {
  Manufacturer: MANUFACTURER_TYPE_VALUE,
  Trader: TRADER_TYPE_VALUE,
  BuyingHouse: BUYING_HOUSE_TYPE_VALUE,
  Wholesaler: WHOLESALER_TYPE_VALUE,
};

export const STATUS = {
  verified: 'verified',
  unverified:'unverified',
  deactivated: 'deactivated',
};

export const PAYMENT_BEFORE_DELIVERY = 5;
export const PAYMENT_NATURE = {
  CREDIT: 'credit',
  PBD: 'PBD',
};

export const INTL_CURRENCY_ID = 2;

export const WEIGHT_UNIT_KG = 'kg';

export const BOOLEAN_TYPE = {
  YES: 1,
  NO: 0,
};
export const BOOLEAN_OPTIONS = [
  { title: 'Yes', value: BOOLEAN_TYPE.YES },
  { title: 'No', value: BOOLEAN_TYPE.NO },
];

export const ECOMMERCE_PLATFORMS_TYPE = {
  MYNTRA: 1,
  AJIO: 2,
  MEESHO: 3,
  AMAZON: 4,
  FLIPCART: 5,
  SHOPSY: 6,
  JIOMART: 7,
  FIRSTCRY: 8,
  OTHERS: 100,
};

export const ECOMMERCE_PLATFORMS_OPTIONS = [
  { title: 'Myntra', value: ECOMMERCE_PLATFORMS_TYPE.MYNTRA },
  { title: 'Ajio', value: ECOMMERCE_PLATFORMS_TYPE.AJIO },
  { title: 'Meesho', value: ECOMMERCE_PLATFORMS_TYPE.MEESHO },
  { title: 'Amazon', value: ECOMMERCE_PLATFORMS_TYPE.AMAZON },
  { title: 'Flipkart', value: ECOMMERCE_PLATFORMS_TYPE.FLIPCART },
  { title: 'Shopsy', value: ECOMMERCE_PLATFORMS_TYPE.SHOPSY },
  { title: 'JioMart', value: ECOMMERCE_PLATFORMS_TYPE.JIOMART },
  { title: 'Firstcry', value: ECOMMERCE_PLATFORMS_TYPE.FIRSTCRY },
  { title: 'Others', value: ECOMMERCE_PLATFORMS_TYPE.OTHERS },
];
